import { Home, UtensilsCrossed, Activity, User, Camera } from "lucide-react";
import { NavLink } from "@/projects/Admin_Bite_Balance/bite-balance/src/components/NavLink";
import { useNavigate } from "react-router-dom";
import { cn } from "@/projects/Admin_Bite_Balance/bite-balance/src/lib/utils";

const BottomNav = () => {
  const navigate = useNavigate();

  const navItems = [
    { path: "/home", icon: Home, label: "Home" },
    { path: "/meals", icon: UtensilsCrossed, label: "Meals" },
    { path: "/fitness", icon: Activity, label: "Fitness" },
    { path: "/profile", icon: User, label: "Profile" },
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50">
      <div className="mx-auto max-w-md px-4 pb-4">
        <div className="rounded-[1.75rem] border border-border/50 bg-card/95 shadow-lg backdrop-blur-xl">
          <div className="relative flex items-center justify-between px-6 py-3">
            {/* First two items */}
            {navItems.slice(0, 2).map(item => {
              const Icon = item.icon;
              return (
                <NavLink
                  key={item.path}
                  to={item.path}
                  className="flex flex-col items-center gap-1 rounded-xl px-3 py-2 transition-all"
                  activeClassName="text-primary"
                >
                  <Icon className="h-5 w-5" />
                  <span className="text-[10px] font-medium">{item.label}</span>
                </NavLink>
              );
            })}

            {/* Spacer for camera button */}
            <div className="w-12" />

            {/* Last two items */}
            {navItems.slice(2, 4).map(item => {
              const Icon = item.icon;
              return (
                <NavLink
                  key={item.path}
                  to={item.path}
                  className="flex flex-col items-center gap-1 rounded-xl px-3 py-2 transition-all"
                  activeClassName="text-primary"
                >
                  <Icon className="h-5 w-5" />
                  <span className="text-[10px] font-medium">{item.label}</span>
                </NavLink>
              );
            })}

            {/* Floating Camera Button - Centered */}
            <button
              className="absolute -top-7 left-1/2 flex h-14 w-14 -translate-x-1/2 items-center justify-center rounded-full border-4 border-background bg-primary shadow-lg transition-transform hover:scale-105 active:scale-95"
              onClick={() => navigate("/camera")}
            >
              <Camera className="h-6 w-6 text-primary-foreground" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BottomNav;
